import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import {
  useAddFertilizerCategoryMutation, useDeleteFertilizerCategoryMutation, useEditFertilizerCategoryMutation
} from "../../../../../redux/api/handBooksApi/chemicalization/fertilizerCategoryApi";



const useFertilizerCategory = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addFertilizerCategory] = useAddFertilizerCategoryMutation();
  const [deleteFertilizerCategory] = useDeleteFertilizerCategoryMutation();
  const [editFertilizerCategory] = useEditFertilizerCategoryMutation();


  async function onAddFertilizerCategory(newFertilizerCategory: EntDirectoryInfoName): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addFertilizerCategory(newFertilizerCategory).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if(refresh) refresh();
		}
	  }).catch((error:any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteFertilizerCategory(fertilizerCategory: EntDirectoryInfoName) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteFertilizerCategory(fertilizerCategory.id as number).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({title: t('msg.successDelete')});
			  if(refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  }

  async function onEditFertilizerCategory(editedFertilizerCategory: EntDirectoryInfoName): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editFertilizerCategory(editedFertilizerCategory).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({title: t('msg.successEdited')});
		  if(refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  }
  return { onAddFertilizerCategory,onDeleteFertilizerCategory, onEditFertilizerCategory }

}
export { useFertilizerCategory };

